import React from 'react'
import { Table } from 'element-react'

const TableSG = () => {
    // Constructors
    const columns = [
        {
            label: 'Date',
            prop: 'date',
            width: 180,
        },
        {
            label: 'Name',
            prop: 'name',
            width: 180,
        },
        {
            label: 'Address',
            prop: 'address',
        },
    ]
    const data = [
        {
            date: '2016-05-03',
            name: 'Tom',
            address: 'No. 189, Grove St, Los Angeles',
        },
        {
            date: '2016-05-02',
            name: 'Tom',
            address: 'No. 189, Grove St, Los Angeles',
        },
        {
            date: '2016-05-04',
            name: 'Tom',
            address: 'No. 189, Grove St, Los Angeles',
        },
        {
            date: '2016-05-01',
            name: 'Tom',
            address: 'No. 189, Grove St, Los Angeles',
        },
    ]

    return (
        <Table
            style={{ width: '100%' }}
            columns={columns}
            data={data}
            stripe={false}
        />
    )
}

export default TableSG
